export const setToken = (token, expiresIn) => {
  localStorage.setItem("authToken", token);
  const expirationTime = Date.now() + expiresIn * 1000; // Convert seconds to milliseconds
  localStorage.setItem("tokenExpiry", expirationTime);
};

export const getToken = () => {
  const token = localStorage.getItem("authToken");
  const expiry = localStorage.getItem("tokenExpiry");
  if (!token || !expiry) return null;

  if (Date.now() > Number(expiry)) {
    removeToken();
    return null;
  }

  return token;
};

export const removeToken = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("tokenExpiry");
};

export const isAuthenticated = () => {
  return !!getToken();
};
